// extracted by mini-css-extract-plugin
module.exports = {"Logo":"_2isxds1Lt9XG9bto-Se32q"};